export enum NotificationTrigger {
  MISSION_FAILED = 'MISSION_FAILED',
  MISSION_SUCCEEDED = 'MISSION_SUCCEEDED',
  MISSION_SUCCEEDED_WITH_MAINTENANCE = 'MISSION_SUCCEEDED_WITH_MAINTENANCE',
  STATUS_ERROR_CHANGE = 'STATUS_ERROR_CHANGE',
  STATUS_WARNING_CHANGE = 'STATUS_WARNING_CHANGE',
  STATUS_MAINTENANCE_CHANGE = 'STATUS_MAINTENANCE_CHANGE',
  ROBOT_LOST_CONNECTION = 'ROBOT_LOST_CONNECTION',
  DASHBOARD_SUMMARY = 'DASHBOARD_SUMMARY',
  MISSION_SUMMARY = 'MISSION_SUMMARY',

  API_EXPIRING = 'API_EXPIRING',
}

export enum NotificationRepeat {
  END_OF_DAY = 'END_OF_DAY',
  END_OF_WEEK = 'END_OF_WEEK',
  END_OF_MONTH = 'END_OF_MONTH',
}

export enum NotificationGroupType {
  SUMMARY = 'SUMMARY',
  MISSION_BASED = 'MISSION_BASED',
  ORGANIZATION_BASED = 'ORGANIZATION_BASED',
  // STATUS_BASED = "STATUS_BASED",
  // CUSTOM = "CUSTOM",
}

export enum NotificationSendMethod {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
}
